/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostApiPaymentsMutationRequest, PostApiPaymentsMutationResponse, PostApiPaymentsQueryParams, PostApiPayments400, PostApiPayments403, PostApiPayments404, PostApiPayments409, PostApiPayments500 } from "../entities/PostApiPayments";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { postApiPayments } from "../api/postApiPayments";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const postApiPaymentsMutationKey = () => [{ url: '/api/payments' }] as const

export type PostApiPaymentsMutationKey = ReturnType<typeof postApiPaymentsMutationKey>

export function postApiPaymentsMutationOptions<TContext = unknown>(config: Partial<RequestConfig<PostApiPaymentsMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = postApiPaymentsMutationKey()
        return mutationOptions<PostApiPaymentsMutationResponse, ResponseErrorConfig<PostApiPayments400 | PostApiPayments403 | PostApiPayments404 | PostApiPayments409 | PostApiPayments500>, {data: PostApiPaymentsMutationRequest, params: PostApiPaymentsQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ data, params }) => {
            return postApiPayments(data, params, config)
          },
        })

}

/**
 * @description Создаёт платёж ЮKassa для группы записей и возвращает ссылку на оплату
 * @summary Создать платёж
 * {@link /api/payments}
 */
export function usePostApiPayments<TContext>(options: 
{
  mutation?: UseMutationOptions<PostApiPaymentsMutationResponse, ResponseErrorConfig<PostApiPayments400 | PostApiPayments403 | PostApiPayments404 | PostApiPayments409 | PostApiPayments500>, {data: PostApiPaymentsMutationRequest, params: PostApiPaymentsQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<PostApiPaymentsMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? postApiPaymentsMutationKey()

          const baseOptions = postApiPaymentsMutationOptions(config) as UseMutationOptions<PostApiPaymentsMutationResponse, ResponseErrorConfig<PostApiPayments400 | PostApiPayments403 | PostApiPayments404 | PostApiPayments409 | PostApiPayments500>, {data: PostApiPaymentsMutationRequest, params: PostApiPaymentsQueryParams}, TContext>
          

          return useMutation<PostApiPaymentsMutationResponse, ResponseErrorConfig<PostApiPayments400 | PostApiPayments403 | PostApiPayments404 | PostApiPayments409 | PostApiPayments500>, {data: PostApiPaymentsMutationRequest, params: PostApiPaymentsQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<PostApiPaymentsMutationResponse, ResponseErrorConfig<PostApiPayments400 | PostApiPayments403 | PostApiPayments404 | PostApiPayments409 | PostApiPayments500>, {data: PostApiPaymentsMutationRequest, params: PostApiPaymentsQueryParams}, TContext>
      
}